import { gql } from "@apollo/client";

const localesGql = gql`
  query getAllLocales($keys: [String!]!) {
    allLocales(keys: $keys) {
      key
      translation
    }
  }
`;

export default localesGql;
